/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Moment_CtaInputs */

const en_us2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the retrospective`)
};

const pt_br2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver retrospectiva`)
};

const es_419_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver la retrospectiva`)
};

const pt_pt2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver retrospetiva`)
};

const fr_fr2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir la rétrospective`)
};

const de_de2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückblick ansehen`)
};

const it_it2_today_moment_cta = /** @type {(inputs: Today_Moment_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi il riepilogo`)
};

/**
* | output |
* | --- |
* | "See the retrospective" |
*
* @param {Today_Moment_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_moment_cta = /** @type {((inputs?: Today_Moment_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Moment_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_moment_cta(inputs)
	if (locale === "es-419") return es_419_today_moment_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_today_moment_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_today_moment_cta(inputs)
	if (locale === "de-DE") return de_de2_today_moment_cta(inputs)
	if (locale === "it-IT") return it_it2_today_moment_cta(inputs)
	return en_us2_today_moment_cta(inputs)
});
export { today_moment_cta as "today.moment_cta" }